import * as Config from '../../../config';
import React, { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import './Input.css';

import Button from '../common/Button';
import { FormContext } from '../../../contexts/form-context';
import { setStateShortcuts } from "../shortcut/redux/actions/index";

function ConnectedInput(props) {
  const { value, placeholder = null, style, modalHasEntered, labelValid, validClick, cancelClick, setStateShortcuts } = props;
  const [val, setVal] = useState(value);
  const inputRef = useRef(null);
  const [focus, setFocus] = useState(false);
  const prepareFocus = (e) => {
    setFocus(true);
    setStateShortcuts(false);
    e.target.select(); //Auto-select
  }
  const prepareBlur = () => {
    setFocus(false);
    setStateShortcuts(true);
  }

  const setValue = (e) => { setVal(e.target.value) }

  useEffect(() => {
    if (modalHasEntered) {
      setTimeout(() => {
        inputRef.current.focus()
      }, 100);
    }
  }, [modalHasEntered]);

  const valid = () => {
    if (val.length > 0) {
      validClick(val);
      cancelClick();
    }
  }

  const onEnterPress = (e) => {
    if (e.charCode === 13 && validClick) {
      valid();
    }
  }
  const onKeyDown = (e) => {
    if (e.keyCode === 8) { //backspace
      e.stopPropagation()
    }
  }

  return (
    <FormContext.Provider value={{data: val}}>
      <div className={`modal-form`} style={{ textAlign: `left` }}>
        <input className={`modal-inputX type-regular`} ref={inputRef} type="text" onChange={setValue} value={val}
          placeholder={placeholder} onKeyPress={onEnterPress} onKeyDown={onKeyDown} onFocus={prepareFocus} onBlur={prepareBlur}
          autoComplete="special"
          style={{ color: focus ? Config.TYPE_LIGHT : Config.TYPE_SECONDARY, ...style }}
        />
      </div>
      <div className={`login-actions flexColumn`}>
        <Button label={labelValid} className={`cta ${val ? `primary` : `bg-black-5`} type-regular type-placeholder`} onClick={valid} />
        <Button label={`Close`} className={`cta cancel`} onClick={cancelClick} />
      </div>

    </FormContext.Provider>
  )
}

ConnectedInput.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  labelValid: PropTypes.string.isRequired,
  validClick: PropTypes.func.isRequired,
  cancelClick: PropTypes.func,
  style: PropTypes.object,
}

const Input = connect(
  null,
  dispatch => ({
    setStateShortcuts: state => dispatch(setStateShortcuts(state))
  })
)(ConnectedInput);

export default Input;
